/**
 * Formats a cents amount as a USD currency string with two decimals
 * (e.g. 1234 → "$12.34"). Shared so the wallet, billing, and top-up
 * surfaces render money identically.
 */
export function formatUsdCents(cents: number): string {
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

/**
 * Formats a cents amount as whole-dollar USD (e.g. 5000 → "$50"). For running
 * copy where cents add noise ("Add your refundable $50").
 */
export function formatUsdCentsWhole(cents: number): string {
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
}
